import style from "./About4.module.css";
import { Steps, Popover } from "antd";
import { useEffect, useState } from "react";
import {
  LeftCircleOutlined,
  RightCircleOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import request from "../../common/request";

import "./About4.css";
const { Step } = Steps;

var list = {
  1: [],
  2015: [
    {
      time1: "5月",
      time2: "08",
      img: require("../../assets/images/test/test2.jpg").default,
      info: "中国人民银行杭州支行和浙江省经济和信息化委员会批准认定资信评级为A单位。",
    },
  ],
  "-1": [],
};

const customDot = (dot, { status, index }) => (
  <label className={style.dotwrap} style={{}}>
    {dot}
  </label>
);

export default function Main() {
  // for (var k in list) {
  //   list2.push(k);
  // }

  var onChange = (current) => {
    setCurrent(current);
  };
  var [current, setCurrent] = useState(2);
  // var [currentList, setCurrentList] = useState(list["2015"]);
  var [currentList, setCurrentList] = useState([]);
  var [dotList, setDotList] = useState([]);

  useEffect(() => {
    var list11 = {};
    request.getColumnList("发展历程").then((result) => {
      var data = result.data.data.data;
      console.log(data);

      list11["1"] = [];
      data.map((e) => {
        // {
        //   time1: "5月",
        //   time2: "08",
        //   img: require("../../assets/images/test/test2.jpg").default,
        //   info: "中国人民银行杭州支行和浙江省经济和信息化委员会批准认定资信评级为A单位。",
        // },
        var o = {};
        o.time1 = e.desc.split("-")["0"] + "月";
        o.time2 = e.desc.split("-")["1"];
        o.img = e.pic
          ? e.pic
          : require("../../assets/images/test/test2.jpg").default;
        o.info = e.content;

        if (!list11[e.title]) list11[e.title] = [];
        list11[e.title].push(o);

        return o;
      });
      list11[-1] = [];
      list = list11;
      console.log("list---", list);

      var list2 = [];
      for (var k in list) {
        list2.push(k);
      }

      setDotList(list2);

      console.log("currentList", dotList, list[list2[current]]);
      setCurrentList(list[list2[current]]);
    });

    //
    // console.log("currentList");
    // console.log(currentList);
  }, [current]);

  return (
    <>
      <h1 className={style.timeTitle}>
        {dotList[current]} <span></span>
      </h1>

      <div className={style.list}>
        {currentList.map((item, index) => {
          console.log(item);
          return (
            <div
              className={`${index % 2 != 0 ? style.highlight : ""} ${
                style.li
              } `}
              key={index}
            >
              <div className={style.lileft}>
                <span>
                  {item.time1} <span className={style.bar2}></span>
                  <br />
                  <label>{item.time2}</label>
                </span>

                <img src={item.img} />
              </div>
              <p>{item.info}</p>
            </div>
          );
        })}
      </div>

      <div>
        <Steps
          current={current}
          progressDot={customDot}
          onChange={onChange}
          style={{ marginBottom: "50px" }}
        >
          {dotList.map((k) => {
            if (k == 1 || k == -1) {
              return <Step disabled description="" key={k} />;
            } else {
              return <Step title={k} description="" key={k} />;
            }
          })}
        </Steps>
        <span
          onClick={() => {
            if (current == 1) {
              return;
            }
            current--;
            setCurrent(current);
          }}
          className={style.stepBtn}
          style={{
            float: "left",
            position: "relative",
            top: "-110px",
            right: "-50px",
          }}
        >
          <LeftOutlined />
        </span>
        <span
          onClick={() => {
            console.log(current, dotList);
            if (current == dotList.length - 2) {
              return;
            }
            current++;
            setCurrent(current);
          }}
          className={style.stepBtn}
          style={{
            float: "right",
            position: "relative",
            top: "-110px",
            right: "50px",
          }}
        >
          <RightOutlined />
        </span>
      </div>
    </>
  );
}
